<div class="uploaded-files-dialog-container p-4">
  <div class="flex flex-col md:flex-row gap-6">

    <!-- Left summary column -->
    <div class="w-full md:w-1/3 flex flex-col gap-4">
      <div class="bg-surface-100 dark:bg-surface-800 p-4 rounded-md shadow-md">
        <h3 class="text-xl font-bold mb-2">{{ translateServ.dictionary['STAT_TOT_UPDS'] }}</h3>
        <p class="text-4xl font-light text-primary-500 mb-2">
          {{ totalFiles | number }}
        </p>
        <p class="text-sm text-surface-600 dark:text-surface-400">
          {{ newFiles | number }} {{ translateServ.dictionary['STAT_TOT_YEAR_UPDS'] }}
        </p>
      </div>

      <div class="bg-surface-100 dark:bg-surface-800 p-4 rounded-md shadow-md">
        <h4 class="text-md font-semibold mb-3 text-surface-700 dark:text-surface-200">{{ translateServ.dictionary['STAT_UPDS_PER_PERIOD'] }}</h4>
        <div class="grid grid-cols-2 gap-y-2 text-sm">
          <span class="font-medium text-surface-600 dark:text-surface-400">{{ translateServ.dictionary['STAT_THIS_YEAR'] }}:</span>
          <span class="text-right font-semibold">{{ uploadedThisYear | number }}</span>

          <span class="font-medium text-surface-600 dark:text-surface-400">{{ translateServ.dictionary['STAT_THIS_MONTH'] }}:</span>
          <span class="text-right font-semibold">{{ uploadedThisMonth | number }}</span>

          <span class="font-medium text-surface-600 dark:text-surface-400">{{ translateServ.dictionary['STAT_THIS_WEEK'] }}:</span>
          <span class="text-right font-semibold">{{ uploadedThisWeek | number }}</span>

          <span class="font-medium text-surface-600 dark:text-surface-400">{{ translateServ.dictionary['STAT_THIS_DAY'] }}:</span>
          <span class="text-right font-semibold">{{ uploadedThisDay | number }}</span>
        </div>
      </div>

      <div class="bg-surface-100 dark:bg-surface-800 p-4 rounded-md shadow-md">
        <h4 class="text-md font-semibold mb-3 text-surface-700 dark:text-surface-200">{{ translateServ.dictionary['STAT_ACT_LEGEND'] }}</h4>
        <div class="flex flex-col gap-2">
          <div class="flex items-center gap-2 text-sm">
            <div class="legend-box" [style.background-color]="lowColor"></div> 
            <span>1-4 {{ translateServ.dictionary['STAT_UPDS'] }}</span>
          </div>
          <div class="flex items-center gap-2 text-sm">
            <div class="legend-box" [style.background-color]="mediumColor"></div> 
            <span>5-14 {{ translateServ.dictionary['STAT_UPDS'] }}</span>
          </div>
          <div class="flex items-center gap-2 text-sm">
            <div class="legend-box" [style.background-color]="highColor"></div> 
            <span>15+ {{ translateServ.dictionary['STAT_UPDS'] }}</span>
          </div>
          <div class="flex items-center gap-2 text-sm">
            <div class="legend-box" style="background-color: #eee;"></div>
            <span>0 {{ translateServ.dictionary['STAT_UPDS'] }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Right GitHub-style grid -->
    <div class="w-full md:w-2/3 flex flex-col justify-center items-center">
      <h3 class="text-lg font-bold mb-4 text-center">{{ translateServ.dictionary['STAT_DIALOG_TIT'] }}</h3>
      <div class="activity-grid-wrapper flex justify-center">
        <div class="activity-grid">
          <div class="week" *ngFor="let week of weeks">
            <div class="day" *ngFor="let day of week"
                 [ngStyle]="{'background-color': getHeatColor(day.count)}"
                 [pTooltip]="day.count + ' ' + translateServ.dictionary['STAT_DIALOG_TOLTIP_UPLS'] + ' ' + (day.date | date:'mediumDate')"
                 tooltipPosition="top">
            </div>
          </div>
        </div>
      </div>

      <p-progressBar *ngIf="loading" mode="indeterminate" class="mt-4 w-full"></p-progressBar>
      <p *ngIf="error" class="text-red-500 mt-4">{{ error }}</p>
    </div>

  </div>
</div>